import React from 'react';
import { Tooltip } from '@mui/material';
import { LucketItem } from './lucket/LucketItem.cmp';
import { countDoneWeekBucketsForBucket } from './slice/lucket-model/countBuckets';

/**
 * Renders a single category of buckets with minimize/expand functionality
 */
export const BucketCategory = ({
    category,
    filteredBuckets,
    buckets,
    currentDate,
    isMinimized,
    onToggleMinimize,
    onExpandBucket
}) => {
    const categoryBuckets = filteredBuckets
        .filter((l) => l.category === category)
        .filter((l) => !l.parentRowID || l.parentRowID === "");

    return (
        <div key={category} style={{ width: "100%" }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <h1 style={{ flex: 1 }}>{category}</h1>
                <div style={{ flex: 6 }} />
                <div
                    style={{ display: "flex", flex: 1 }}
                    onClick={onToggleMinimize}
                >
                    {!isMinimized ? (
                        <Tooltip title="Minimize Category">
                            <img
                                style={{ width: "20px", margin: "auto", cursor: "pointer" }}
                                src="/images/up-arrow.svg"
                                alt="Minimize"
                            />
                        </Tooltip>
                    ) : (
                        <Tooltip title="Expand Category">
                            <img
                                style={{ width: "20px", margin: "auto", cursor: "pointer" }}
                                src="/images/down-arrow.svg"
                                alt="Expand"
                            />
                        </Tooltip>
                    )}
                </div>
            </div>

            {!isMinimized && categoryBuckets.map((bucket) => {
                const childLuckets = filteredBuckets
                    .filter((l) => l.parentRowID == bucket.rowID && l.parentRowID !== "")
                    .sort((a, b) => a.order - b.order);

                return (
                    <div key={bucket.rowID} style={{ width: "100%" }}>
                        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                            <div className="lucketItemContainer1" style={{ alignItems: "center" }}>
                                <LucketItem
                                    countWeekDonePoints={countDoneWeekBucketsForBucket(
                                        buckets,
                                        currentDate,
                                        bucket
                                    )}
                                    childLuckets={childLuckets}
                                    planView
                                    lucket={bucket}
                                />
                            </div>

                            {childLuckets.length > 0 && (
                                <div className="expandBucketButton">
                                    <Tooltip title="Expand Bucket">
                                        <img
                                            src="/images/up-arrow.svg"
                                            onClick={() => onExpandBucket(bucket.rowID)}
                                            style={{
                                                flex: 1,
                                                height: "20px",
                                                width: "20px",
                                                marginLeft: "10px",
                                                cursor: "pointer",
                                            }}
                                            alt="Expand"
                                        />
                                    </Tooltip>
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
